<template>
    <div>
        <div class="alert small" :class="error.password == 'not-error' ? 'alert-success' : 'alert-danger'" v-if="error.password" @click="error.password = ''">
            <template v-if="error.password == 'error'">Terjadi kesalahan, silahkan coba lagi.</template>
            <template v-else-if="error.password == 'not-error'">Password berhasil diubah.</template>
            <template v-else-if="error.password == 'wrong-old-password'">Password lama salah.</template>
            <template v-else-if="error.password == 'not-match-new-confirm'">Password baru dan Konfirmasi password tidak sama.</template>
        </div>

        <div class="form-group">
            <label class="small">Password Lama</label>
            <vs-input v-model="password.old" placeholder="Password Lama" type="password">
                <template #icon>
                    <box-icon name="lock"></box-icon>
                </template>
            </vs-input>
        </div>
        <div class="form-group">
            <label class="small">Password Baru</label>
            <vs-input v-model="password.new" placeholder="Password Baru" type="password">
                <template #icon>
                    <box-icon name="lock"></box-icon>
                </template>
            </vs-input>
        </div>
        <div class="form-group">
            <label class="small">Konfirmasi Password</label>
            <vs-input v-model="password.confirm" placeholder="Konfirmasi Password" type="password">
                <template #icon>
                    <box-icon name="lock"></box-icon>
                </template>
            </vs-input>
        </div>

        <div class="mt-4">
            <vs-button block @click="changePassword" :loading="loading.password">Simpan</vs-button>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';
import accountHelper from '@/helpers/account';
import { usersCollection } from '@/helpers/firebase';

export default {
    name: 'password',
    data() {
        return {
            password: {
                old: '',
                new: '',
                confirm: '',
            },
            loading: {
                password: false,
            },
            error: {
                password: '',
            }
        }
    },
    methods: {
        changePassword() {
            if(this.password.old && this.password.new && this.password.confirm) {
                let account = accountHelper.getIdUser();
                if(account) {
                    this.loading.password = true;

                    firebase.auth().signInWithEmailAndPassword(account.email, this.password.old).then(() => {
                        if(this.password.new == this.password.confirm) {
                            firebase.auth().currentUser.updatePassword(this.password.new).then(() => {
                                usersCollection.doc(account.email).update({ password: this.password.new, updated_at: new Date() });

                                this.password = {
                                    old: '',
                                    new: '',
                                    confirm: '',
                                };

                                this.error.password = 'not-error';
                                this.loading.password = false;
                            }).catch(err => {
                                console.log('error update password', err);
                                this.error.password = 'error';
                                this.loading.password = false;
                            });
                        } else {
                            this.loading.password = false;
                            this.error.password = 'not-match-new-confirm';
                        }
                    }).catch(err => {
                        console.log('error check password', err.code);
                        this.error.password = 'wrong-old-password';
                        this.loading.password = false;
                    });
                } else {
                    this.error.password = 'error';
                }
            }
        }
    }
}
</script>